import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Members from './pages/Members';
import StudentCouncil from './pages/StudentCouncil';
import Event from './pages/Events';
import Events2025 from './pages/Events2025';
import ContactUsPage from './pages/ContactUs';
import Gallery from './pages/Gallery';
import SeoManager from './components/SeoManager';

function App() {
  return (
    <Router>
      <SeoManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/membership/:year" element={<Members />} />
        <Route path="/student-council/:year" element={<StudentCouncil />} />

        {/* Specific page for 2025 events (Cyber Jagrit Bharat) */}
        <Route path="/events/2025-2026" element={<Events2025 />} />

        {/* Generic events page (e.g., 2024–2025) */}
        <Route path="/events/:year" element={<Event />} />

        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
    </Router>
  );
}

export default App;
